import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=b85ecd10&scoped=true&"
import script from "./FormTemplate.vue?vue&type=script&lang=ts&"
export * from "./FormTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./FormTemplate.vue?vue&type=style&index=0&id=b85ecd10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85ecd10",
  null
  
)

export default component.exports